/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { GET_ALL_APPLICATIONS, SET_NO_APPLICATION, SET_SELECTED_APPLICATION, REMOVE_APPLICATION } from "./types";

export const getAllApplicationAction = (applications: any, selectedApplication: any, noApplication: boolean) => {
  return {
    type: GET_ALL_APPLICATIONS,
    applications,
    selectedApplication,
    noApplication
  };
};

export const setSelectedApplicationAction = (selectedApplication: any) => {
  return {
    type: SET_SELECTED_APPLICATION,
    selectedApplication,
  };
};

export const setNoApplicationAction = (noApplication: boolean) => {
  return {
    type: SET_NO_APPLICATION,
    noApplication,
  };
};

export const removeApplicationAction = (applicationId: string) => {
  return {
    type: REMOVE_APPLICATION,
    applicationId,
  };
}
